import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, serviceJsonLd, webPageJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import { validateAuditReturnSearch } from "@/lib/audit-return-search";

const PATH = "/shopify-performance";

export const Route = createFileRoute("/shopify-performance")({
  validateSearch: validateAuditReturnSearch,
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "en",
    title: "Shopify Performance Optimization & Core Web Vitals · Shugert",
    description: "Shugert is a Shopify performance optimization agency for established stores. Diagnose and fix LCP, INP, CLS, app bloat, JavaScript and theme bottlenecks from $2,500.",
    path: PATH,
    altPath: alternatePath(PATH, "es"),
    ogImage: "/og-performance-v2.jpg",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Home", path: "/" }, { name: "Shopify Performance", path: PATH }]),
      serviceJsonLd({
        name: "Shopify Performance Optimization",
        description: "Shugert provides Shopify performance optimization for LCP, INP and CLS, including app and third-party script audits, JavaScript and CSS work, image loading, theme performance and comparable before/after validation.",
        path: PATH,
        serviceType: "Shopify Performance Optimization Agency",
        minPrice: 2500,
        maxPrice: 4000,
        unit: "PROJECT",
        locale: "en",
      }),
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: [
          {
            "@type": "Question",
            name: "Will performance work break my theme or apps?",
            acceptedAnswer: { "@type": "Answer", text: "We work in an unpublished theme, document affected apps and test representative storefront states before production. Any app removal, deferral or behavior change requires evidence, QA and explicit approval. Rollback and verification remain part of the release plan." },
          },
          {
            "@type": "Question",
            name: "How do I know the results are real?",
            acceptedAnswer: { "@type": "Answer", text: "We preserve the affected URL, template, device and connection context, repeat comparable lab tests and monitor field data over time. Search Console and CrUX use rolling real-user windows, so deployment and population-level validation are reported separately." },
          },
        ],
      },
      webPageJsonLd({ name: "Shopify Performance Optimization & Core Web Vitals Engineering", path: PATH, description: "Shugert provides field-data-led Shopify performance optimization for LCP, INP, CLS, app and theme bottlenecks with staged implementation and comparable validation.", inLanguage: "en-US" }),
    ],
  }),
});
